import React, { Component } from "react";
import Table from "../common/table";
import Avatar from "react-avatar";

class ProyectosTable extends Component {
  getSociosString = (socios) => {
    let returnString = [];
    socios.map((socio, index) => {
      returnString.push(
        <li key={socio._id} className="list-inline-item">
          <Avatar
            className="table-avatar"
            name={socio.persona.nombre + " " + socio.persona.apellido}
            size="40"
            round="100%"
            src={socio.persona.avatar}
          />
        </li>,
      );
    });
    return <ul className="list-inline">{returnString}</ul>;
  };

  getDireccion = (record) => {
    let returnJSX = [];
    returnJSX.push(
      <a key={Math.random()} style={{ cursor: "pointer" }}>
        {record.nombre}
      </a>,
    );
    returnJSX.push(<br key={Math.random()} />);
    returnJSX.push(<small key={Math.random()}>{record.ubicacion}</small>);
    return <>{returnJSX}</>;
  };

  columns = [
    // {
    //   path: "apellido",
    //   sort: (item) => item.apellido.toLowerCase(),
    //   label: "Apellido/R.Social",
    //   width: "20%",
    //   onClick: (record) => this.props.onView(record._id),
    //   // content: (record) => (
    //   //   <Link to={`/ntes/${record._id}`}>{record.apellido}</Link>
    //   // ),
    // },
    {
      content: (item) => this.getDireccion(item),
      sort: (item) => item.nombre.toLowerCase(),
      label: "Nombre",
      width: "40%",
      key: Math.random(),
      onClick: (record) => this.props.onView(record._id),
    },
    {
      path: null,
      label: "Socios",
      sort: (item) => item.socios.length.toString().padStart(9, "0"),
      key: Math.random(),
      width: "60%",
      content: (item) => this.getSociosString(item.socios),
      onClick: (record) => this.props.onView(record._id),
    },
    {
      // key: "edit",
      content: (record) =>
        this.props.permisos.canModify ? (
          <i className="fa fa-edit clickable" aria-hidden="true" onClick={() => this.props.onEdit(record._id)}></i>
        ) : (
          ""
        ),
      isicon: true,
      onClick: (record) => this.props.onEdit(record._id),
      dataClass: "text-olive-disabled",
    },
    {
      // key: "delete",
      content: (record) =>
        this.props.permisos.canDelete ? (
          <i
            className="fas fa-trash-alt clickable"
            aria-hidden="true"
            onClick={() => this.props.onDelete(record._id)}
          ></i>
        ) : (
          ""
        ),
      isicon: true,
      onClick: (record) => this.props.onDelete(record._id),
      dataClass: "text-danger-disabled",
    },
    // <ul className="list-inline">
    //   {record.socios.map((socio, index) => {
    //     return (
    //       <li key={socio._id} className="list-inline-item">
    //         {socio.persona && (
    //           <Avatar
    //             className="table-avatar"
    //             name={socio.persona.nombre + " " + socio.persona.apellido}
    //             size="40"
    //             round="100%"
    //             src={socio.persona.avatar}
    //           />
    //         )}
    //       </li>
    //     );
    //   })}
    // </ul>,

    // {
    //   path: "cuit",
    //   label: "CUIT",
    //   width: "70%",
    //   onClick: (record) => this.props.onView(record._id),
    // },
    // { path: "dailyRentalRate", label: "Rate" },
    // {
    //   key: "like",
    //   content: (movie) => (
    //     <Like onClick={() => this.props.onLike(movie)} liked={movie.liked} />
    //   ),
    // },
  ];

  //   componentWillMount = () => {
  //     const { permisos } = this.props;
  //     if (permisos.canModify)
  //       this.columns.push({
  //         key: "edit",
  //         content: (record) => (
  //           <i className="fa fa-edit clickable" aria-hidden="true" onClick={() => this.props.onEdit(record._id)}></i>
  //         ),
  //         isicon: true,
  //         dataClass: "text-olive-disabled",
  //       });

  //     if (permisos.canDelete)
  //       this.columns.push({
  //         key: "delete",
  //         content: (record) => (
  //           <i
  //             className="fa fa-trash-alt clickable"
  //             aria-hidden="true"
  //             onClick={() => this.props.onDelete(record._id)}
  //           ></i>
  //         ),
  //         isicon: true,
  //         dataClass: "text-danger-disabled",
  //       });
  //     // this.setState({ columns });
  //   };

  render() {
    const { records, sortColumn, onSort } = this.props;

    return (
      <Table
        data={records}
        columns={this.columns}
        fullClass="table table-striped table-hover dataTable dtr-inline projects"
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default ProyectosTable;
